import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { purchaseFreeProduct } from '../../../api/purchase.js';
import { EVENTS } from '../../../constants/events.js';
import { PURCHASE_STATUSES } from '../../../constants/purchaseStatuses.js';
import events from '../../event/index.js';
import { getCategories } from './categories.js';
import { getProducts } from './products.js';
import { getUser } from './user.js';
import settings from '../../../settings.js';
import { error, warn } from '../../../utils/logger.js';
import { redirectToUrl } from '../../../utils/redirectToUrl.js';

function checkout(externalProductId, quantity, customStorefrontName, customFields) {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield getUser();
        if (settings.redirectToUserAuthEnabled) {
            if (!user.isLoggedIn && settings.userAuthUrl) {
                redirectToUrl(settings.userAuthUrl);
                throw new Error('User not logged in');
            }
        }
        const productEntities = yield getProducts(customStorefrontName);
        const productEntity = productEntities.find((productEntity) => productEntity.externalProductId === externalProductId);
        if (!productEntity) {
            error('[Web]', 'Product not found', externalProductId, productEntities);
            return { purchaseStatus: PURCHASE_STATUSES.ERROR };
        }
        const storefrontName = customStorefrontName || settings.storefrontName;
        if (productEntity.price === 0) {
            events.emit(EVENTS.SET_FETCHING, { visibility: true });
            const purchaseResult = { purchaseStatus: PURCHASE_STATUSES.ERROR };
            try {
                yield purchaseFreeProduct(productEntity, quantity, storefrontName);
                productEntity.updateLimitAfterSuccessPurchase();
                const categoryEntities = yield getCategories();
                events.emit(EVENTS.PRODUCTS_UPDATE, { storefrontName, products: productEntities });
                events.emit(EVENTS.CATEGORIES_UPDATE, { storefrontName, categories: categoryEntities });
                purchaseResult.purchaseStatus = PURCHASE_STATUSES.SUCCESS;
            }
            catch (e) {
                warn('Failed to purchase a free product', e);
            }
            finally {
                events.emit(EVENTS.SET_FETCHING, { visibility: false });
            }
            return purchaseResult;
        }
        const productQuantity = quantity || 1;
        const { default: createPurchaseConfirmation } = yield import('../../../ui/PurchaseConfirmation/index.js');
        const purchaseResult = yield createPurchaseConfirmation(productEntity.code, events, productQuantity, customStorefrontName, customFields);
        if (purchaseResult.purchaseStatus === PURCHASE_STATUSES.SUCCESS) {
            productEntity.updateLimitAfterSuccessPurchase();
            const categoryEntities = yield getCategories();
            events.emit(EVENTS.PRODUCTS_UPDATE, { storefrontName, products: productEntities });
            events.emit(EVENTS.CATEGORIES_UPDATE, { storefrontName, categories: categoryEntities });
        }
        return purchaseResult;
    });
}

export { checkout };
//# sourceMappingURL=checkout.js.map
